import { Currency } from '@websky/core/src/enums';
import { Money } from '@websky/graphql';

export function needShowWarning(priceToPayTotal: Money) {
	return priceToPayTotal.currency !== Currency.RUB && priceToPayTotal.amount > 0;
}
